export default {
  path: '/park/leaseContract',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'leaseList',
      name: 'leaseList',
      component: () => import('@/pages/superviseContract/LeaseContract/index.vue'),
      meta: {
        keepAlive: true,
        title: '三方仓库租赁合同管理',
      },
    },
    {
      path: 'leaseDetail',
      name: 'leaseDetail',
      component: () =>
        import('@/pages/superviseContract/LeaseContract/LeaseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '三方仓库租赁合同维护',
      },
    },
    {
      path: 'leaseContractAgreement',
      name: 'leaseContractAgreement',
      component: () =>
        import('@/pages/superviseContract/LeaseContract/LeaseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '三方仓库租赁合同补充协议',
      },
    },
    {
      path: 'leaseContractRenew',
      name: 'leaseContractRenew',
      component: () =>
        import('@/pages/superviseContract/LeaseContract/LeaseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '三方仓库租赁合同续签',
      },
    },
    {
      path: 'leaseContractChange',
      name: 'leaseContractChange',
      component: () =>
        import('@/pages/superviseContract/LeaseContract/LeaseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '三方仓库租赁合同变更',
      },
    },
  ],
};
